/**
 * Represents a Streaming or Other Media Type
 */
export enum MediaType {
  /**
   * Indicates Dash Adaptive Streaming Format
   */
  DASH = 'dash',

  /**
   * Indicates Microsoft Smooth Streaming Adaptive Format
   */
  SMOOTH_STREAMING = 'ss',

  /**
   * Indicates HTTP Live Streaming Adaptive Format
   */
  HLS = 'hls',

  /**
   * Indicates Media Container format MP4
   */
  MP4 = 'mp4',

  /**
   * Indicates other Media Container formats such as MP4 , WMV etc.,
   */
  OTHER = 'other',
}
